import React, { Fragment, useMemo, useState } from 'react';
import { Button, Card, Col, Icon, Input, InputNumber, message, Row, Table, Tag, Tooltip } from 'antd';
import SelectInfinitePro from '../../../../components/common/select-infinite-pro';
import * as CommonService from '../../../../services/CommonService';
import { PRODUCT_ENDPOINT } from '../../../../services/endpoint';
import { currencyVND, formatCurrency, parserNumber } from '../../../../utils';

export default (props) => {

	const { mapImei, setMapImei, selectedProduct, setSelectedProduct } = props;

	// const { getFieldDecorator } = props.form;

	const [value, setValueState] = useState({});
	const [selectedValue, setSelectedValue] = useState(null);

	// const [totalDiscount, setTotalDiscount] = React.useState(0);

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={2}>{label}</Col>
			<Col span={22}>: {value || '---'}</Col>
		</Row>
	);

	const handleSelect = async (value) => {
		if (value) {
			if (selectedProduct.some(el => el.id === value.id)) {
				message.error('Bạn đã chọn sản phẩm này rồi', 100);
				return;
			}
			window.setLoading(true);
			const response = await CommonService.findById(PRODUCT_ENDPOINT, value.id);
			const data = response.data || {};
			data.quantity = 0;
			setSelectedProduct([...selectedProduct, data]);
			window.setLoading(false);
			return true;
		}
	};

	const setValue = (idx, key, value) => {
		selectedProduct[idx][key] = value;
		setSelectedProduct([...selectedProduct]);
	};

	const columns = [
		{
			title: 'Thao tác',
			width: 100,
			align: 'center',
			render: (record, re, idx) => <Button type="link" onClick={() => {
				const newSelectedProduct = selectedProduct.filter(el => el.id !== record.id);
				setSelectedProduct([...newSelectedProduct]);
				delete mapImei[idx];
			}} >X</Button>
		},
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'name',
			key: 'name',
			width: 300,
			render: (text, record) => {
				return <Fragment><Row>
					<Col>
						<b>{text}</b>
					</Col>
				</Row>
					<Row gutter={12} style={{ marginTop: 10 }}>
						<Col>
							<Button type="dashed" onClick={() => {
								window.open(`/product/${record.id}`);
							}}>{record.code}</Button>
						</Col>
					</Row>
				</Fragment>;
			}
		},
		{
			title: 'Phân Loại',
			dataIndex: 'isNormal',
			key: 'isNormal',
			align: 'center',
			width: 100,
			render: (isNormal) => {
				return isNormal ? <Tag color="magenta">Sản phẩm thường</Tag> : <Tag color="green">Serial/IMEI</Tag>;
			}
		},
		{
			title: 'Đơn vị',
			dataIndex: 'unitName',
			align: 'center',
			key: 'unitName',
			width: 150
		},
		{
			title: () => renderTitle('SL nhập', 'Cho phép nhập số lượng nếu là sản phẩm thường'),
			width: 150,
			align: 'center',
			render: (value, record, idx) => {
				return record.isNormal ? <InputNumber
					style={{ width: '100%' }}
					min={0}
					formatter={formatCurrency}
					parser={parserNumber}
					onChange={(value) => {
						setValue(idx, 'quantity', value);
					}}
					value={record.quantity || 0} /> : mapImei[idx]?.length || 0;
			}
		},
		{
			title: 'Đơn giá',
			dataIndex: 'importPrice',
			key: 'importPrice',
			width: 150,
			align: 'center',
			render: (value, record, idx) => {
				return <InputNumber
					style={{ width: '100%' }}
					formatter={formatCurrency}
					parser={parserNumber}
					min={0}
					onChange={(value) => {
						setValue(idx, 'importPrice', value);
					}}
					value={record.importPrice || 0} />;
			}
		},
		{
			title: 'Chiết khấu',
			dataIndex: 'discount',
			key: 'discount',
			width: 150,
			align: 'center',
			render: (value, record, idx) => {
				return <InputNumber
					style={{ width: '100%' }}
					formatter={formatCurrency}
					parser={parserNumber}
					min={0}
					onChange={(value) => {
						setValue(idx, 'discount', value);
					}}
					value={record.discount || 0} />;
			}
		},
		{
			title: 'Thành tiền',
			width: 150,
			align: 'center',
			render: (record, r, idx) => {
				const qtt = record.isNormal ? (record.quantity || 1) : mapImei[idx]?.length || 0;
				return <>{`${currencyVND((qtt * (record.importPrice || 0)) - (record.discount > 0 ? record.discount * qtt : 0))}`}</>;
			}
		}
	];

	const renderTitle = (title, tooltipContent) => {
		return <Fragment>
			<span>{title} <Tooltip title={tooltipContent}><Icon type="info-circle" /></Tooltip></span>
		</Fragment>;
	};

	const handleRemoveImei = (idx, imei) => {
		mapImei[idx] = mapImei[idx]?.filter(el => el !== imei) || [];
		setMapImei({ ...mapImei });
	};

	const getExpandedRowKeys = () => {
		return selectedProduct.filter(el => !el.isNormal).map(el => el.id);
	};

	const handleAddImei = (evt, idx) => {
		if (evt.key === 'Enter') {
			const v = evt.target.value;
			if (v) {
				const existed = Object.keys(mapImei).some(el => mapImei[el]?.includes(v));
				if (existed) {
					message.error('Bạn đã nhập IMEI này rồi');
					return;
				}
				mapImei[idx] = mapImei[idx] || [];
				mapImei[idx].push(v);
				setMapImei({ ...mapImei });
				value[idx] = '';
				setValueState({ ...value });
			}
		}
	};

	const existedImei = (imei) => {
		return mapImei?.existed?.includes(imei) || false;
	};

	const renderOptions = el => {
		return <Row>
			<Col span={20}>
				<b>{el.name}</b>
			</Col>
			<Col span={4} style={{ textAlign: 'right' }}>
				Giá nhập: {currencyVND(el.importPrice)}
			</Col>
			<Col span={20}>
				<i>{el.code}</i>
			</Col>
			<Col span={4} style={{ textAlign: 'right' }}>
				Tồn: {<span style={{ color: el.stockQuantity === 0 ? 'red' : 'blue' }}>{el.stockQuantity}</span>}
				{/*| Có thể bán: 100*/}
			</Col>
		</Row>;
	};

	const expandedRowRender = (record, idx) => {
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<Input value={value[idx]}
							 onKeyDown={evt => handleAddImei(evt, idx)}
							 onChange={e => {
								 value[idx] = e.target.value;
								 setValueState({ ...value });
							 }}
							 placeholder={'Nhập và Enter số Serial/IMEI'} />
				<div className={'mt-20'}>
					<i>Danh sách IMEI ({mapImei[idx]?.length || 0}): </i>{mapImei[idx]?.map((el) => <Tag
					color={existedImei(el) ? 'red' : ''} key={el} closable
					onClose={() => handleRemoveImei(idx, el)}>
					{el}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	const sum = useMemo(() => {
		let totalQuantity = 0;
		let sumPrice = 0;
		selectedProduct.forEach((el, idx) => {
			if (el.isNormal) {
				totalQuantity += el.quantity || 1;
				sumPrice += ((el.quantity || 1) * (el.importPrice || 0)) - (el.discount > 0 ? el.quantity * el.discount : 0);
			} else {
				totalQuantity += mapImei[idx]?.length || 0;
				sumPrice += ((mapImei[idx]?.length || 0) * (el.importPrice || 0)) - (el.discount > 0 ? mapImei[idx]?.length * el.discount : 0);
			}
		});
		return {
			totalQuantity,
			sumPrice
		};
	}, [selectedProduct, mapImei]);
	const renderFooter = () => {
		return <Fragment>
			<InfoRow label={'Số lượng'} value={selectedProduct.length > 0 ? sum.totalQuantity : '---'} />
			<InfoRow label={'Tổng tiền'} value={selectedProduct.length > 0 ? currencyVND(sum.sumPrice) : '---'} />
			{/*<Row style={{ marginBottom: 8 }}>*/}
			{/*<Row style={{ marginBottom: 8 }}>*/}
			{/*	<Col span={2}>{'Chiết khấu'}</Col>*/}
			{/*	<Col span={22}>: {selectedProduct.length > 0 ? getFieldDecorator(`discount`)(<InputNumber*/}
			{/*		formatter={formatCurrency}*/}
			{/*		parser={parserNumber}*/}
			{/*		min={0}*/}
			{/*		max={sum.sumPrice}*/}
			{/*		value={totalDiscount}*/}
			{/*		onChange={(value) => setTotalDiscount(value)}*/}
			{/*		style={{ width: '200px' }}*/}
			{/*		placeholder={'Nhập số tiền chiết khấu'} />) : '---'}</Col>*/}
			{/*</Row>*/}
			<InfoRow label={<b>Tiền cần trả</b>}
							 value={selectedProduct.length > 0 ? currencyVND(sum.sumPrice) : '---'} />
		</Fragment>;
	};


	return (
		<Fragment>
			<Card title={<Fragment><Icon type="inbox" /> Thông tin sản phẩm</Fragment>} className={'mt-20'}>
				<Row gutter={12}>
					<Col>
						<SelectInfinitePro endpoint={PRODUCT_ENDPOINT}
															 handleSelect={handleSelect}
															 placeholder={'Tìm theo tên, mã...'}
															 dataOption={el => el}
															 customOption={renderOptions}
															 value={selectedValue}
						/>
					</Col>
					<Col>
						<Table
							className={'purchase-order-table'}
							rowKey={'id'}
							dataSource={selectedProduct}
							columns={columns}
							rowClassName="editable-row"
							pagination={false}
							expandIconAsCell={false}
							expandedRowRender={expandedRowRender}
							expandedRowKeys={getExpandedRowKeys()}
							expandIcon={() => ''}
						/>
					</Col>
					<Col className={'mt-20'}>
						{renderFooter()}
					</Col>
				</Row>
			</Card>
		</Fragment>
	);
};
